import { Fragment, useState, useEffect } from 'react';
import { useGetTitularidadContratosCdcQuery } from "../../../redux/reducers/titularidadcontratosSlice";
import { useGetContratosQuery, useClasesContratosQuery } from "../../../redux/reducers/contratosSlice";
//React Vertical Time Line
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { useGetPersonasQuery } from "../../../redux/reducers/personasSlice";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IconButton from '@mui/material/IconButton';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import Grow from '@mui/material/Grow';
import AddIcon from '@mui/icons-material/Add';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import CloseIcon from "@mui/icons-material/Cancel"
import EditIcon from '@mui/icons-material/Edit';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VerifiedIcon from '@mui/icons-material/Verified';
import Popover from '@mui/material/Popover';

import {
    Button, Box, Avatar, List, ListItem, ListItemAvatar, ListItemText, DialogTitle, Dialog, Typography, DialogContent,
    TextField, FormControl, OutlinedInput, FormHelperText, InputLabel, FilledInput, Grid, DialogContentText, DialogActions
} from '@mui/material';
import { getEstadosHistoricosCDC, getEstadosHistoricosCDCTitularidades } from '../../../edilia/index'
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentUser } from "../../../redux/reducers/authSlice"
import {
    DataGridPro, GridToolbarQuickFilter, gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton,
    GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';

import { getThemeProps } from '@mui/system';
import theme from "../../../theme";
import { getTitularidadesData } from "./titularidadesSlice.js";

const zfill = (number, width) => {
    var numberOutput = Math.abs(number); /* Valor absoluto del número */
    var length = number.toString()?.length; /* Largo del número */
    var zero = "0"; /* String de cero */

    if (width <= length) {
        if (number < 0) {
            return ("-" + numberOutput.toString());
        } else {
            return numberOutput.toString();
        }
    } else {
        if (number < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
        } else {
            return ((zero.repeat(width - length)) + numberOutput.toString());
        }
    }
};
function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
};
function getFecha(date) {
    date = new Date(parseInt(date)).toLocaleString().split(",");
    date = date[0].split("/");

    let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
    let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
    let y = date[2];
    return d + '/' + m + '/' + y
};
const fechaSortComparator = (v1, v2, param1, param2) => {
    function getFechaNumero(date) {
        date = date.split('/')
        let d = date[0]
        let m = date[1]
        let y = date[2];
        var fullDate = y + m + d;
        return parseInt(fullDate);
    }
    let fecha1 = getFechaNumero(param1.value)
    let fecha2 = getFechaNumero(param2.value)
    const ComparatorResult = gridNumberComparator(
        fecha1,
        fecha2,
    );
    if (ComparatorResult !== 0) {
        return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
};
const importeSortComparator = (v1, v2, param1, param2) => {
    function getImporteNumero(importe) {
        importe = importe.replace('$', '').replace(',', '').replace('.', '')
        return parseInt(importe);
    }
    let number1 = getImporteNumero(param1.value)
    let number2 = getImporteNumero(param2.value)
    const ComparatorResult = gridNumberComparator(
        number1,
        number2,
    );
    if (ComparatorResult !== 0) {
        return ComparatorResult;
    }
    return gridNumberComparator(v1.name, v2.name, param1, param2);
};
const getMedioPago = (medioId) => {
    if (medioId === 1) {
        return 'Manual'
    }
    if (medioId === 2) {
        return 'Cuenta Recaudadora'
    }
    if (medioId === 3) {
        return 'Debito Directo'
    }
    if (medioId === 4) {
        return 'GetNet'
    }
}
const getDescripcionPago = (des) => {
    let instrumento = ''
    let estado = ''
    des = des.split('#')
    let acreditacion = des[1]
    des = des[0]
    switch (true) {
        case des.startsWith('EFECTIVO'):
            instrumento = 'Efectivo Pesos';
            break;
        case des.startsWith('CH24SRIO') || des.startsWith('ECH24SRI'):
            instrumento = 'Cheque 24/Santander';
            break;
        case des.startsWith('CH48SRIO') || des.startsWith('ECH48SRI'):
            instrumento = 'Cheque 48/Santander';
            break;
        case des.startsWith('CH72SRIO') || des.startsWith('ECH72SRI'):
            instrumento = 'Cheque 72/Santander';
            break;
        case des.startsWith('CH48CC') || des.startsWith('ECH48CC'):
            instrumento = 'Cheque 48 CC';
            break;
        case des.startsWith('CPD') || des.startsWith('ECPD'):
            instrumento = 'Cheque Pago Diferido';
            break;
        case des.startsWith('DBCTA'):
            instrumento = 'Débito en cuenta';
            break;
        case des.startsWith('CH24CL') || des.startsWith('ECH24CL'):
            instrumento = 'Cheque 48 Cámara local';
            break;
        case des.startsWith('SNP$'):
            instrumento = 'Débito en cuenta SNP $';
            break;
        case des.startsWith('EFERAPI'):
            instrumento = 'Efectivo Rapipago';
            break;
        case des.startsWith('INTERPGO'):
            instrumento = 'Interpago (Pagos Interbanking)';
            break;
        case des.startsWith('VCTRUNC') || des.startsWith('EVCTRUNC'):
            instrumento = 'Valores al Cobro Truncados';
            break;
        case des.startsWith('CL48TRUN') || des.startsWith('ECL48TRU'):
            instrumento = 'Cámara local 48 horas Truncado';
            break;
        case des.startsWith('TR-SNP'):
            instrumento = 'Transferencias CBU Recaudadora - SNP';
            break;
        case des.startsWith('TR-ANET'):
            instrumento = 'Transferencias CBU Recaudadora - Interbanking';
            break;
        case des.startsWith('NOFINANC'):
            instrumento = 'Pago no financiero';
            break;
        case des.startsWith('TBANELCO'):
            instrumento = 'Transferencias CBU Recaudadora – BANELCO';
            break;
        case des.startsWith('DEBIN'):
            instrumento = 'DEBIN Pesos';
            break;
        case des.startsWith('EFECU$S'):
            instrumento = 'Efectivo Dólares';
            break;
        case des.startsWith('DBCTAU$S'):
            instrumento = 'Débito en cuenta Dólares';
            break;
        case des.startsWith('DEBINU$S'):
            instrumento = 'DEBIN Dolares';
            break;
        default:
            // Manejar el caso por defecto si no se cumple ninguna condición
            break;
    }
    switch (acreditacion) {
        case ' ':
        case 'A':
        case 'B':
        case 'E':
            estado = 'Acreditado';
            break;
        case 'S':
            estado = 'Acreditado';
            break;
        case 'R':
            estado = 'Rechazado';
            break;
        case 'D':
            estado = 'Diferido';
            break;
        case 'P':
            if (des.startsWith('EFERAPI')) {
                estado = 'Acredita a las 48HS.';
            }
            if (des.startsWith('INTERPGO')) {
                estado = 'Pendiente (no vino información de interbanking)';
            }
            break;
        case 'T':
            estado = 'Rescatado';
            break;
        case 'C':
            estado = 'Cesionado desde la custodia';
            break;
        case 'Y':
            estado = 'Fallas técnicas o cheque posdatado';
            break;
        case 'V':
            estado = 'Faltante';
            break;
        case 'X':
            estado = 'Rechazo con posible redepósito';
            break;
        case 'U':
            estado = 'Rechazo con redepósito';
            break;
        case 'Z':
            estado = 'Cheque no redepositado';
            break;
        default:
            // Manejar el caso por defecto si no se cumple ninguna condición
            break;
    }
    return instrumento + ' - ' + estado

}
const getLabel = (option) => {
    if (option.personaFisica) {
        if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
        return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
    } else {
        if (!option.denominacionSocial && !option.cuit) return option.email;
        return option.denominacionSocial + ' - ' + option.cuit;
    }
};
const TitularidadesCat = () => {
    const currentUser = useSelector(selectCurrentUser);
    const dispatch = useDispatch();
    const { personas, clasesContratos, titularidadesCdc, contratos } = useSelector(state => state.titularidades.data);
    useEffect(() => { dispatch(getTitularidadesData()) }, []);

    const Header = (props) => {
        const fetching = useSelector(state => state.titularidades.fetching);
        return (<Fragment>
            <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>{'Titularidades'}</Typography>
            {fetching > 0 && <p>Cargando</p>}
        </Fragment>);
    };

    const TitularidadesTable = (props) => {
        const fetching = useSelector(state => state.titularidades.fetching);
        const moneyFormat = (v) => new Intl.NumberFormat("es-ES", { style: "currency", currency: "ARS" }).format((parseFloat(v)).toFixed(2)).replace("ARS", "");
        const [detallesTitularidad, setDetallesTitularidad] = useState(false);
        const openDetallesTitularidad = () => setDetallesTitularidad(true);
        const closeDetallesTitularidad = () => setDetallesTitularidad(false);
        const [columnVisibilityModel, setColumnVisibilityModel] = useState({
            titularidadId: false,
        });
        let historic = []
        //Divido el cdc en arrays por titularidadContratosId para después aplicar a cada conjunto la función que ordena el historial
        const resultado = titularidadesCdc ? titularidadesCdc?.reduce((acc, registro) => {
            const { titularidadContratosId } = registro;

            const titularidadContratosIdExistente = acc.find((grupo) => grupo[0]?.titularidadContratosId === titularidadContratosId);
            if (titularidadContratosIdExistente) {
                titularidadContratosIdExistente.push(registro);
            } else {
                acc.push([registro]);
            }
            return acc;
        }, []) : null;
        resultado?.forEach(r => {
            historic = historic?.concat(getEstadosHistoricosCDCTitularidades(r.sort((a, b) => parseInt(a.fechaEdicion) - parseInt(b.fechaEdicion)))
                ?.map((t, i) => ({
                    ...t,
                    action: i === 0 ? 'Creación' : t.eliminado ? 'Fin de titularidad.' : 'Edición',
                    fechaAplicacionDesde: getFecha(t.fechaAplicacionDesde),
                    fechaAplicacionHasta: getFecha(t.fechaAplicacionHasta) === '01/01/9999' ? 'Indef.' : getFecha(t.fechaAplicacionHasta),
                    porcentaje: t.partes + '%'
                })))
                ?.filter(t => (t.fechaAplicacionDesde !== t.fechaAplicacionHasta) || t.eliminado)
        });
        let rows = //((titularidades || []))?.map(t => {
            ((historic || []))?.map(t => {
                let tipologia = clasesContratos?.find(x => parseInt(x.claseContratoId) === (contratos || [])?.find(c => parseInt(c.contratoId) === parseInt(t.contratoId))?.claseContratoId)?.codigo
                let persona = (personas || [])?.find(p => p.personaId === parseInt(t.personaId))
                return ({
                    ...t,
                    titularidadId: t.titularidadContratosId,
                    tipologia,
                    porcentaje: t.partes + '%',
                    nombreTitular: getLabel(persona),
                    vigente: t.eliminado ? false : true,
                })
            }).sort((a, b) => b.titularidadId - a.titularidadId);
        const DetallesTitularidad = (props) => {
            const getActionIcon = (titularidad) => {
                switch (titularidad.action) {
                    case 'Creación':
                        return <PersonAddIcon />;
                    case 'Edición':
                        return <EditIcon />;
                    case 'Fin de titularidad.':
                        return <PersonRemoveIcon />
                    default:
                        break;

                }
            };
            const titularidadCdc = titularidadesCdc?.filter(t => t.titularidadContratosId === detallesTitularidad?.titularidadContratosId)?.sort((a, b) => parseInt(a.fechaEdicion) - parseInt(b.fechaEdicion))?.map(t => ({ ...t, fechaAplicacionHasta: null }))
            const timeLineCdc = getEstadosHistoricosCDC(titularidadCdc ? titularidadCdc : [])?.map((t, i) => ({
                ...t,
                action: i === 0 ? 'Creación' : t.eliminado ? 'Fin de titularidad.' : 'Edición',
                fechaAplicacionDesde: getFecha(t.fechaAplicacionDesde),
                fechaAplicacionHasta: getFecha(t.fechaAplicacionHasta) === '01/01/9999' ? 'Indef.' : getFecha(t.fechaAplicacionHasta),
                porcentaje: t.partes + '%'
            }))?.filter(t => !(t.fechaAplicacionDesde === t.fechaAplicacionHasta))
            const titularidad = detallesTitularidad
            const VerticalTimeLineReactUse = () => {
                return (
                    <Fragment>
                        <VerticalTimeline lineColor='#65D673' layout='2-columns'>
                            {timeLineCdc?.map((actual, i) => {
                                return (
                                    <Fragment key={'VerticalTimeLine' + i}>
                                        <VerticalTimelineElement
                                            className="vertical-timeline-element--work"
                                            iconStyle={{ background: '#65D673', color: '#fff' }}
                                            icon={getActionIcon(actual)}
                                            date={<Typography sx={{ padding: '0 1rem 0', marginBottom: '1rem' }} children={actual.fechaAplicacionDesde + ' - ' + actual.fechaAplicacionHasta} />}
                                        >
                                            <Typography variant="h5" component="span">
                                                {actual.eliminado ? 'Fin de la titularidad.' : actual.porcentaje}
                                            </Typography>
                                            <Typography color="text.secondary" children={actual.porcentaje === timeLineCdc[i - 1]?.porcentaje || i === 0 || actual.eliminado ? '' : ((actual.partes - timeLineCdc[i - 1]?.partes >= 0 ? '+' : '') + actual.partes - timeLineCdc[i - 1]?.partes + '%')} />
                                            <Typography color="text.secondary" >Titular {actual.titularPrincipal ? 'Principal' : 'Secundario'} {actual.titularPrincipal ? <VerifiedIcon color='primary' sx={{ paddingTop: '0.3rem' }} /> : null}</Typography>
                                        </VerticalTimelineElement>
                                        {/* {i === timeLineCdc?.length - 1 && actual.eliminado?
                                          <VerticalTimelineElement
                                          className="vertical-timeline-element--work"
                                          iconStyle={{ background: '#65D673', color: '#fff' }}
                                          icon={<PersonRemoveIcon/>}
                                          date={<Typography sx={{padding: '0 1rem 0', marginBottom: '1rem'}}  children={actual.fechaAplicacionDesde + ' - ' + actual.fechaAplicacionHasta} />}
                                      >
                                          <Typography variant="h5" component="span">
                                              {}
                                          </Typography>
                                          
                                      </VerticalTimelineElement>
                                            : null} */}
                                    </Fragment>
                                )
                            })
                            }
                        </VerticalTimeline>
                    </Fragment>
                )
            }
            return (
                <Fragment>
                    <Dialog maxWidth='lg' minWidth='lg' onClose={closeDetallesTitularidad} open={detallesTitularidad} >
                        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Detalles titularidad {titularidad?.nombreTitular} Contrato {titularidad?.contratoId}</DialogTitle>
                        <DialogContent dividers>
                            <div style={{ zoom: "0.8" }}>
                                <VerticalTimeLineReactUse />

                            </div>
                            {/* <Grow in={timeLineCdc ? { timeout: 8000 } : false}> */}
                            {/* 

                                        <Timeline position="alternate">
                                            {timeLineCdc?.map((actual, i) => {
                                                return (
                                                    <Fragment key={'DetalleTitularidad' + i}>
                                                        <TimelineItem>
                                                            <TimelineOppositeContent
                                                                sx={{ m: 'auto 0' }}
                                                                align="right"
                                                                variant="body2"
                                                                color="text.secondary"
                                                            >
                                                                {actual.fechaAplicacionDesde}
                                                            </TimelineOppositeContent>
                                                            <TimelineSeparator>
                                                                <TimelineConnector />
                                                                <TimelineDot color="primary">
                                                                    {getActionIcon(actual)}
                                                                </TimelineDot>
                                                                <TimelineConnector />
                                                            </TimelineSeparator>
                                                            <TimelineContent sx={{ py: '12px', px: 2 }}>
                                                                <Typography variant="h5" component="span">
                                                                    {actual.porcentaje}
                                                                </Typography>
                                                                <Typography color="text.secondary" >Titular {actual.titularPrincipal ? 'Principal' : 'Secundario'}</Typography>
                                                            </TimelineContent>
                                                        </TimelineItem>
                                                        {i === timeLineCdc?.length - 1 ?
                                                            <TimelineItem>
                                                                <TimelineOppositeContent
                                                                    sx={{ m: 'auto 0' }}
                                                                    align="right"
                                                                    variant="body2"
                                                                    color="text.secondary"
                                                                >
                                                                    {actual.fechaAplicacionHasta}
                                                                </TimelineOppositeContent>
                                                                <TimelineSeparator>
                                                                    <TimelineConnector />
                                                                    <TimelineDot color="primary">
                                                                        {actual.fechaAplicacionHasta === 'Indef.' ?
                                                                            <AllInclusiveIcon /> :
                                                                            <PersonRemoveIcon />}
                                                                    </TimelineDot>
                                                                    <TimelineConnector />
                                                                </TimelineSeparator>
                                                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                                                    <Typography variant="h5" component="span">
                                                                        {actual.porcentaje}
                                                                    </Typography>
                                                                    <Typography color="text.secondary" >Titular {actual.titularPrincipal ? 'Principal' : 'Secundario'}</Typography>
                                                                </TimelineContent>
                                                            </TimelineItem>
                                                            : null}
                                                    </Fragment>
                                                )
                                            })}
                                        </Timeline> */}
                            {/* </Grow> */}
                        </DialogContent>
                        <DialogActions style={{ marginTop: '10px', marginLeft: '5px' }}>
                            <Button
                                variant="outlined"
                                onClick={closeDetallesTitularidad}
                                sx={{ marginRight: '5px', marginButtom: '15px', fontWeight: "bold" }}>
                                {'Volver'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Fragment>
            );
        };
        const GridAction = (props) => {
            const [anchorEl, setAnchorEl] = useState(null);

            const handlePopoverOpen = (event) => {
                setAnchorEl(event.currentTarget)
            };

            const handlePopoverClose = () => {
                setAnchorEl(null)
            };
            const { label, key, Icon } = props;
            const open = Boolean(anchorEl);
            return (
                <Fragment key={key + label}>
                    <Icon aria-owns={open ? label : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}> </Icon>
                    <Popover
                        id={label}
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>{label}</Typography>
                    </Popover>
                </Fragment>
            )
        };
        const columns = [
            { field: 'id', headerName: 'ID', width: 100 },
            { field: 'action', headerName: 'Acción', width: 100 },
            { field: 'contratoId', headerName: 'ID Contrato', width: 100, },
            { field: 'tipologia', headerName: 'Tipologia', width: 100, },
            { field: 'personaId', headerName: 'Titular ID', width: 100, },
            { field: 'nombreTitular', headerName: 'Nombre', width: 200, },
            { field: 'porcentaje', headerName: 'Porcentaje', width: 100, renderCell: v => <Typography sx={{ margin: 'auto' }} children={v.row.porcentaje} /> },
            { field: 'titularPrincipal', headerName: 'Principal', width: 100, renderCell: v => v.row.titularPrincipal ? <VerifiedIcon sx={{ margin: 'auto' }} color="primary" /> : <CloseIcon sx={{ color: theme.palette.secondary.main, margin: 'auto' }} />, valueGetter: v => v.row.titularPrincipal ? 1 : 0 },
            { field: 'vigente', headerName: 'Vigente', width: 100, renderCell: v => v.row.vigente ? 'Sí' : 'No', valueGetter: v => v.row.vigente ? 1 : 0 },
            { field: 'fechaAplicacionDesde', headerName: 'Desde', width: 200, sortComparator: fechaSortComparator },
            { field: 'fechaAplicacionHasta', headerName: 'Hasta', width: 100, sortComparator: fechaSortComparator },
            // {
            //     field: 'actions', headerName: 'Acciones', width: 10, type: 'actions', renderCell: v =>
            //         <>
            //             <GridActionsCellItem key={v.row.titularidadId + '-VerDetallesGridAction'} color={'primary'} onClick={() => setDetallesTitularidad(v.row)} icon={<GridAction label={'Ver Detalles'} key={v.row.titularidadId} Icon={VisibilityIcon} />} />
            //         </>
            // }
        ];

        return (
            <Fragment>
                <DetallesTitularidad />
                <Box fullWidth sx={{ width: '100%' }}>
                    <DataGridPro
                        fullWidth
                        pagination
                        sx={{ height: '75vh' }}
                        getRowId={r => r.id}
                        rows={currentUser?.permisos?.find(p => p === "readContratos") ? rows : []}
                        columns={columns}
                        columnVisibilityModel={columnVisibilityModel}
                        onColumnVisibilityModelChange={setColumnVisibilityModel}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'contratoId', sort: 'desc' }],
                            },
                        }}
                        components={{
                            Toolbar: () => {
                                return <Fragment>
                                    <GridToolbarContainer>
                                        <Grid conteiner
                                            rowSpacing={0} sx={{
                                                display: "inline-flex",
                                                justifyContent: "space-between",
                                                alignItems: "strech",
                                                width: "100%"
                                            }}>
                                            <Grid sx={{ width: "100%" }}>
                                                <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                                                {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                                                    : ''}
                                            </Grid>
                                            <GridToolbarQuickFilter />
                                        </Grid>
                                    </GridToolbarContainer>
                                </Fragment>
                            }
                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                        loading={fetching > 0}
                    />
                </Box>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Header></Header>
            <TitularidadesTable />
        </Fragment>
    )
};

export default TitularidadesCat;